import {getAllGTINs} from '@/services/PromotionsService/promotionProductSelection'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {useQuery} from '@tanstack/react-query'

export const useGetAllGtins = (page = 0, size = DEFAULT_TABLE_PAGE_SIZE, gtinId) => {
  const query = useQuery({
    queryKey: ['GTINS', page, size, gtinId],
    queryFn: () => {
      const params = {page, size}
      if (gtinId) {
        params.gtinId = gtinId
      }
      return getAllGTINs(params)
    },
  })

  return query
}
